import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ISession } from '../../../models/session';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';
import { UsersService } from '../users/users.service';
import { environment as config } from '../../../../environments/environment';

// Loaded by <script> from .angular-cli.json (src/vendor/module-bridge.js)
declare const LiveeBridge: any;

@Component({
  selector: 'app-event-manager',
  templateUrl: './event-manager.component.html',
  styleUrls: ['./event-manager.component.scss']
})
export class EventManagerComponent implements OnInit, AfterViewInit, OnDestroy {
  public iframeUrl: SafeResourceUrl;
  public session: ISession;
  public isLoading: boolean = true;

  @ViewChild('emFrame') private frame: ElementRef;
  private moduleOrigin: string = null;
  private bridge: any = null;

  constructor(
    private sanitizer: DomSanitizer,
    private route: ActivatedRoute,
    private router: Router,
    private usersService: UsersService,
  ) {}

  ngOnInit() {
    this.route.parent.data
      .map(route => route.data)
      .subscribe((session: ISession) => {
        this.session = session;
        this.usersService.getSpecialUsers(session.id).subscribe(specials => {
          const modUser = specials.find((s: any) => s.type === 'M');
          if (!modUser) {
            console.log(`Moderator user not found for session: ${session.id}`);
          }
          if (modUser) {
            const params = new URLSearchParams();
            params.set('session', session.id.toString());
            params.set('login', 'mod');
            params.set('autologin', 'true');
            params.set('external-css', `${config.livee.tag}/plugins/app/dev/build/2.1/prod/eventmanagerv2.css`);
            params.set('token', modUser.jwt);
            const url = `${this.getEventManagerBase()}?${params.toString()}`;

            // The module's origin comes from the URL the API returned, so there is no second place to keep in sync.
            this.moduleOrigin = this.originOf(url);

            // Tell the module a host is present; the module re-checks hostOrigin against its own allowlist.
            const separator = url.indexOf('?') === -1 ? '?' : '&';
            const withHost = url + separator + 'host=eva&hostOrigin=' + encodeURIComponent(window.location.origin);

            this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(withHost);
          }
          this.isLoading = false;
        }, () => {
          this.isLoading = false;
        });
      });
  }

  ngAfterViewInit() {
    this.bridge = LiveeBridge.createHostBridge({
      // Functions, not values: the iframe sits behind *ngIf and the origin arrives after the API call.
      iframe: () => this.frame && this.frame.nativeElement,
      moduleOrigin: () => this.moduleOrigin,
      name: 'eva',
      // Everything EVA lets the module ask for. The module speaks in intents; EVA owns the routes.
      capabilities: {
        navigate: (payload: { to: string, session: string }) => {
          if (payload && payload.to === 'registration-form' && payload.session) {
            this.router.navigate(['/sessions', payload.session, 'registration']);
          }
        }
      },
      onError: e => console.warn('[bridge]', e.code, e.message)
    });
  }

  ngOnDestroy() {
    if (this.bridge) {
      this.bridge.destroy();
      this.bridge = null;
    }
  }

  private originOf(url: string): string {
    const a = document.createElement('a');
    a.href = url;
    return a.protocol + '//' + a.host;
  }

  private getEventManagerBase(): string {
    const tagUrl = new URL(config.livee.tag);
    return `${tagUrl.protocol}//event-manager.${tagUrl.host}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/event-manager/event-manager.component.ts